module.exports = __webpack_public_path__ + "static/media/space-station-moon.620b92f7.svg";